export default __webpack_public_path__ + "static/nationalUniversity-1003a208c5282296692a81e00ae06b76.png";